import {
    RichTableColumns,
} from 'app/types/richtable.types'

type LoggerTypes = {
    oldLoggerNumber: string,
    newLoggerNumber: string,
    loggerType: string,
}

const columns = ({
    loggerTypes,
    l,
}: {
    loggerTypes: Record<string, string>,
    l: (key: string) => string
}): RichTableColumns<keyof LoggerTypes>[] => {
    return [
        {
            id: 'oldLoggerNumber',
            headerProps: {
                children: l('OLD_LOGGER'),
            },
            mapCellProps: 'oldLoggerNumber',
        },
        {
            id: 'newLoggerNumber',
            headerProps: {
                children: l('NEW_LOGGER'),
            },
            mapCellProps: 'newLoggerNumber',
        },
        {
            id: 'loggerType',
            headerProps: {
                children: l('TYPE'),
            },
            mapCellProps: ({
                loggerType,
            }) => {
                return {
                    children: loggerTypes[loggerType],
                }
            },
        },
    ]
}

export default columns
